export const MAX_FLIGHT_PREFERENCES_LENGTH = 300;